import { render, staticRenderFns } from "./UserCreateForm.vue?vue&type=template&id=0dc9e82b"
import script from "./UserCreateForm.vue?vue&type=script&lang=ts"
export * from "./UserCreateForm.vue?vue&type=script&lang=ts"
import style0 from "./UserCreateForm.vue?vue&type=style&index=0&id=0dc9e82b&prod&lang=scss&scopend=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports